import React from 'react';
import { IconProps } from '.';

const SvgColoredRanking = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#878F91' d='M15.333 2H22v20H2v-6.667h6.667V8.666h6.666V2Z' />
    </svg>
  );
};

export default SvgColoredRanking;
